<template>
  <div class="view box grow">
    <page-headers
        :header="'Confluera Agent Installation'"
        :breadcrumbs="breadcrumbs"
        :is-border="true"
        documentation="page-installation-guide"
        class="box"
    />
    <router-view class="full-height"/>
  </div>
</template>

<script>
import PageHeaders from '@/components/layout/PageHeaders.vue'
import {Rules, PrivilegedRules} from '@/views/rules'

export default {
  name: 'InstallationLanding',
  data() {
    return {
      breadcrumbs: [{title: 'Setup'}, {title: 'Agents'}],
      activeView: 'network',
      routePath: {
        name: 'install-agent'
      }
    }
  },
  beforeMount() {
    // If window refreshed, stay on previous rules page
    if (performance.navigation.type === 1) {
      this.routePath = {
        name: 'install-agent',
        query: {os: this.$route.query.os, version: this.$route.query.version}
      }
      this.$router.push(this.routePath)
      if (this.$route.name === 'install-agent') {
        this.$set(this, 'activeView', 'agent')
      }
    } else {
      // set default path for attack progression rules
      this.$router.push(this.routePath)
    }
  },
  methods: {
    changeView(tab, event) {
      if (tab.name === 'network') {
        this.routePath = {
          name: 'network-req'
        }
        this.$set(this, 'activeView', 'network')
      } else {
        this.routePath = {
          name: 'install-agent',
          query: {os: 'linux', version: 'ubuntu 16.04 lts'}
        }
        this.$set(this, 'activeView', 'agent')
      }
      this.$router.push(this.routePath)
    }
  },
  components: {
    PageHeaders,
    Rules,
    PrivilegedRules
  }
}
</script>



// WEBPACK FOOTER //
// src/views/installation/InstallationLanding.vue